module.exports = __webpack_public_path__ + "img/Frame 1888.3c08fa39.png";